
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function cartCrossSellRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                return _createElement('tr', { 'className': 'cm_cart-cross-sell_item woocommerce-cart-form__cart-item cart_item' }, _createElement('td', {}), _createElement('td', { 'className': 'product-thumbnail' }, _createElement('a', { 'href': this.url }, _createElement('img', {
                    'loading': 'lazy',
                    'decoding': 'async',
                    'width': '1000',
                    'height': '1000',
                    'className': 'attachment-woocommerce_thumbnail size-woocommerce_thumbnail',
                    'src': this.imageOrDefault(this.image),
                    'onError': this.onImageError
                }))), _createElement('td', {
                    'className': 'product-name',
                    'data-title': 'Product'
                }, _createElement('div', {}, _createElement('a', Object.assign({}, { 'href': this.url }, { dangerouslySetInnerHTML: { __html: this.name } })))), _createElement('td', {
                    'className': 'product-price',
                    'data-title': 'Price'
                }, _createElement('span', { 'className': 'woocommerce-Price-amount amount' }, _createElement('bdi', {}, this.formatPrice(this.price)))), _createElement('td', {
                    'className': 'product-add',
                    'data-title': 'Add'
                }, _createElement('a', {
                    'href': this.url,
                    'data-quantity': '1',
                    'type': 'submit',
                    'data-product_id': this.product_id,
                    'data-product_sku': this.removeHTML(this.sku),
                    'rel': 'nofollow',
                    'className': 'button product_type_variation add_to_cart_button ajax_add_to_cart',
                    'aria-label': 'Add to cart: \u201C' + this.removeHTML(this.name) + '\u201D'
                }, '\n            Add\n          ')), _createElement('td', {}));
            }, { count: undefined })];
    }
    return _createElement('table', { 'className': 'cm_cart-cross-sell_container' }, _createElement('tbody', {}, _createElement('tr', { 'className': 'cm_cart-cross-sell_title' }, _createElement('td', { 'colSpan': '6' }, _createElement('h4', {}, 'Do you need lug nuts or install kit?'))), _createElement.apply(this, [
        'div',
        { 'className': 'cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ])));
}
        export const componentNames = []